import { Injectable, computed, inject, signal } from '@angular/core';
import { SmartAiService } from './smart-ai.service';

/**
 * Global open/close state for the slide-in SEMAR chat panel.
 * Shared by the topbar "Ask AI" button, the floating FAB, and the panel itself.
 * Mirrors ThemeService (signal-based, providedIn root).
 */
@Injectable({ providedIn: 'root' })
export class SemarPanelService {
  private smartAi = inject(SmartAiService);

  private readonly _isOpen = signal(false);
  readonly isOpen = computed(() => this._isOpen());

  /** Reset backend chat context only once per session, on first open. */
  private historyReset = false;

  open(): void {
    this._isOpen.set(true);
    if (!this.historyReset) {
      this.historyReset = true;
      this.smartAi.resetHistory();
    }
  }

  close(): void {
    this._isOpen.set(false);
  }

  toggle(): void {
    this._isOpen() ? this.close() : this.open();
  }
}
